export default {
    _prefix: "DivisionSelector",
    labels: {
        divisionId: "Division",
        placeholder: "Search or select a division",
        loading: "Loading divisions...",
        divisionOptions: "Available divisions",
    },
    errors: {
        failedToLoad: "Failed to load divisions",
        divisionRequired: "Division selection is required",
    },
};
